// The filter type names, these need to match the filter type value specified from the API data on each of the filter options
export const FILTER_TYPE_MULTI_CHECKBOX = 'multi-checkbox';
export const FILTER_TYPE_SINGLE_CHECKBOX = 'single-checkbox';
export const FILTER_TYPE_KEYWORDS = 'keywords';
export const FILTER_TYPE_TAGS = 'tags';
export const FILTER_TYPE_DATERANGE = 'date-range';
export const FILTER_TYPE_DROPDOWN = 'dropdown';
